import React, { useEffect, useRef } from 'react';

// Cloudflare Turnstile — захист форм від ботів.
// Використання: <TurnstileWidget key={tsKey} onToken={setTsToken} />
// Щоб отримати новий токен (наприклад, після невдалої відправки) — змініть key.
const SITE_KEY = '0x4AAAAAAFpob9x6zQg1DBtF'; // публічний ключ, його можна тримати в коді

let scriptPromise = null;
function loadTurnstile() {
  if (window.turnstile) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = resolve;
      s.onerror = () => { scriptPromise = null; reject(new Error('Turnstile failed to load')); };
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
}

function TurnstileWidget({ onToken }) {
  const boxRef = useRef(null);
  const widgetIdRef = useRef(null);
  const onTokenRef = useRef(onToken);
  onTokenRef.current = onToken;

  useEffect(() => {
    let cancelled = false;
    onTokenRef.current('');
    loadTurnstile()
      .then(() => {
        if (cancelled || !boxRef.current) return;
        widgetIdRef.current = window.turnstile.render(boxRef.current, {
          sitekey: SITE_KEY,
          callback: (token) => onTokenRef.current(token),
          'expired-callback': () => onTokenRef.current(''),
          'error-callback': () => onTokenRef.current(''),
        });
      })
      .catch(() => onTokenRef.current(''));
    return () => {
      cancelled = true;
      if (widgetIdRef.current != null && window.turnstile) {
        try { window.turnstile.remove(widgetIdRef.current); } catch { /* ignore */ }
      }
    };
  }, []);

  return <div ref={boxRef} style={{ margin: '10px 0', minHeight: '65px' }} />;
}

export default TurnstileWidget;
